import { restClient } from '../config/restClient'

const v1Endpoint = (hiringTeamsIdParam, meta) =>
  meta ? `/api/hiring_teams/${meta.hiring_team_id}/interview_requests` : `/api/hiring_teams/${hiringTeamsIdParam}/interview_requests`

const v2Endpoint = (hiringTeamsIdParam, meta) => {
  const hiringTeamsId = meta ? meta.hiring_team_id : hiringTeamsIdParam
  return `/api/company/v2/hiring_teams/${hiringTeamsId}/interview_requests`
}

export const createInterviewRequest = async (hiringTeamsIdParam, data, meta) => {
  const response = await restClient(v1Endpoint(hiringTeamsIdParam, meta), {
    method: 'POST',
    data,
  })

  return response.data
}

export const fetchInterviewRequest = async (hiringTeamId, interviewRequestId) => {
  const response = await restClient(`${v2Endpoint(hiringTeamId)}/${interviewRequestId}`, {
    method: 'GET',
  })
  return response.data
}

export const patchInterviewRequest = async (hiringTeamId, interviewRequestId, data) => {
  const response = await restClient(`${v2Endpoint(hiringTeamId)}/${interviewRequestId}`, {
    method: 'PATCH',
    data,
  })

  return response.data
}

export const fetchInterviewRequests = async (hiringTeamsIdParam, params, meta) => {
  const response = await restClient(v2Endpoint(hiringTeamsIdParam, meta), {
    method: 'GET',
    params,
  })

  return response.data
}
